const klaviyoScript = 'https://a.klaviyo.com/media/js/onsite/onsite.js';

/*
  # onKlaviyoReady
  
  This function assumes that the `klaviyoScript` above has been loaded and
  the `klaviyo` object is available to enable the 'backinstock' component.
*/
function onKlaviyoReady() {
  klaviyo.init({
    account: "XggCUE",
    platform: "shopify"
  });
  
  klaviyo.enable("backinstock", { 
    trigger: {
      product_page_text: "Notify Me When Available",
      product_page_class: "btn",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
      headline: "{product_name}",
      body_content: "Register to receive a notification when this item comes back in stock.",
      email_field_label: "Email",
      button_label: "NOTIFY ME WHEN AVAILABLE",
      subscription_success_label: "You're in! We'll let you know when it's back.",
      footer_content: '',
      additional_styles: "#newsletter_subscription {display: none;} p.small-print, p {font-size: 18px;} .btn {font-family: 'Open Sans'; letter-spacing: 3.84px; font-weight: 500;}",
      drop_background_color: "#000",
      background_color: "#fff",
      text_color: "#222",
      button_text_color: "#fff",
      button_background_color: "#000",
      close_button_color: "#ccc",
      error_background_color: "#fcd6d7",
      error_text_color: "#C72E2F",
      success_background_color: "#d3efcd",
      success_text_color: "#1B9500",
      footer_content: "By using our back in stock mailers you are consenting to occasional updates from Charli.com with regards to marketing activities. Unsubscribe anytime using the links in every email.",
      font_family: "GillSansMTPro-Light",
      headers_font_family: "SilkSerif-ExtraLight",
      newsletter_subscribe_label: "Add me to your newsletter email list.",
      subscribe_checked: true
    }
  });
}


/*
  # loadScript

  Dynamically loads a script into the DOM with a callback function
  to execute once the script has loaded.
*/
function loadScript(url, callback) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  script.onload = callback;
  document.body.appendChild(script);
}


/*
  # Observer

  I have had to add an observer to the page due to CookieYes Consent, 
  which causes a disconnect between our expectation when `klaviyoScript` 
  loads and when it actually loads.

  To make doubly sure we check:
  a) If the script has already loaded we can "safely" execute `onKlaviyoReady()`
  b) If the script is still loading we can listen to the load event and then
     execute the `onKlaviyoReady()` function.
     
*/
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type !== 'childList') {
      return;
    }
    mutation.addedNodes.forEach(function(node) {
      if (node.tagName !== 'SCRIPT' || node.src !== klaviyoScript) {
        return;
      }
      if (node.readyState === 'complete' || node.readyState === 'loaded') {
        onKlaviyoReady();
        observer.disconnect();
        return;
      }
      node.onload = () => {
        onKlaviyoReady();
        observer.disconnect();
      }
    });
  });
});
observer.observe(document.body, { childList: true, subtree: true });


/*
  # Initialize

  Attempt to load the `klaviyoScript` dynamically into the page. 
  This may get blocked temporarily by CookieYes until consent is obtained. 
  Which is why we have the observer.
*/
loadScript(klaviyoScript, onKlaviyoReady);


